import { useEffect } from "react";
import { Layout } from "lola-framework-ui-test";
import type { AuraLayoutProps } from "lola-framework-ui-test";

/**
 * Drop-in replacement for lola's AuraLayout without route slide transitions.
 * The library wraps AuraLayout in MotionWrapper (framer-motion); m2m navigation
 * uses plain Layout instead so screen changes feel instant.
 */
export const AuraLayout = ({
  children,
  colorConfig,
  className = "",
}: AuraLayoutProps) => {
  const {
    themeType,
    dropzoneColors,
    iconColors,
    background,
    useSystemTheme,
    viewConfig,
  } = colorConfig;

  const isDark = themeType === "dark";
  const auraColors = (isDark ? dropzoneColors : iconColors) as [string, string];
  const whiteViewBg =
    useSystemTheme && ["whiteView", "dataView"].includes(viewConfig)
      ? "white-view-background"
      : "";

  useEffect(() => {
    if (!useSystemTheme) {
      document.documentElement.classList.add("light");
    }
  }, [useSystemTheme]);

  const layoutClassName = [whiteViewBg, className, isDark ? "dark" : "light"]
    .filter(Boolean)
    .join(" ");

  return (
    <Layout
      background={background}
      auraColors={auraColors}
      className={layoutClassName}
    >
      {children}
    </Layout>
  );
};
